import { NoCommitment, Cancel } from '../../Icons';

import styles from './styles.module.scss';

const PurchaseConditionsIcons = ({ isOneTimeFeePurchase, guaranteeDays }) => (
  <div className={styles.container}>
    <div className={styles.infoContainer}>
      <NoCommitment />
      {isOneTimeFeePurchase ? (
        <span>
          No hidden or
          <br />
          recurring fees
        </span>
      ) : (
        <span>
          No
          <br />
          commitments
        </span>
      )}
    </div>
    <div className={styles.infoContainer}>
      <Cancel />
      {isOneTimeFeePurchase ? (
        <span>
          {guaranteeDays}-day refund
          <br />
          No questions
        </span>
      ) : (
        <span>
          Cancel
          <br />
          anytime
        </span>
      )}
    </div>
  </div>
);

export default PurchaseConditionsIcons;
